var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaximize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "maximize",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9215",
    "data-name": "Path 9215",
    d: "M17.708,20H2.292A2.294,2.294,0,0,1,0,17.708V2.292A2.294,2.294,0,0,1,2.292,0H17.708A2.294,2.294,0,0,1,20,2.292V17.708A2.294,2.294,0,0,1,17.708,20ZM2.292,1.25A1.043,1.043,0,0,0,1.25,2.292V17.708A1.043,1.043,0,0,0,2.292,18.75H17.708a1.043,1.043,0,0,0,1.042-1.042V2.292A1.043,1.043,0,0,0,17.708,1.25Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9216",
    "data-name": "Path 9216",
    d: "M262.042,92a.625.625,0,0,1-.625-.625V86.582h-4.792a.625.625,0,0,1,0-1.25h5.417a.625.625,0,0,1,.625.625v5.417A.625.625,0,0,1,262.042,92Zm0,0",
    transform: "translate(-246 -81.999)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9217",
    "data-name": "Path 9217",
    d: "M213.965,93.65a.625.625,0,0,1-.442-1.068l7.083-7.083a.625.625,0,1,1,.884.884l-7.083,7.083A.623.623,0,0,1,213.965,93.65Zm0,0",
    transform: "translate(-205.006 -81.984)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9218",
    "data-name": "Path 9218",
    d: "M6.875,327.5a.625.625,0,0,1-.625-.625V321.25H.625a.625.625,0,0,1,0-1.25h6.25a.625.625,0,0,1,.625.625v6.25A.625.625,0,0,1,6.875,327.5Zm0,0",
    transform: "translate(0 -307.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.0c4ee5ce17dbabf91bbef818eb07bf71.svg";
export { ForwardRef as ReactComponent };